export enum DocumentCenterPrivacyType {
  ALL = "ALL",
  PERSONAL = "PERSONAL",
  LAZO = "LAZO",
}
